/**
 * KAN-988: обёртка маршрута по функции кабинета.
 * KAN-1000: тарифов нет, экрана блокировки нет. Доступность решает useFeature
 * (зарегистрированные функции открыты всегда); выключенная неизвестная функция
 * просто не рисуется. API обёртки сохранён, чтобы маршруты не менялись.
 */
import type { ReactNode } from 'react';
import { useFeature } from '@/hooks/useFeature';

interface FeatureGuardProps {
  feature: string;
  children: ReactNode;
}

export function FeatureGuard({ feature, children }: FeatureGuardProps) {
  const enabled = useFeature(feature);
  return enabled ? <>{children}</> : null;
}
